// extracted by mini-css-extract-plugin
export default {"small-card":"styles_small-card__Y8X6f"};